
const VideoSection = () => {
  const videos = [
    {
      title: "Ostersonntagpredigt 2017, Jerusalem Erlöserkirche",
      url: "https://www.youtube.com/embed/cPw08a0pKB8"
    },
    {
      title: 'Poetry Slam "Der Wirt von Bethlehem", 2015',
      url: "https://www.youtube.com/embed/WqFExVvGKaE"
    },
    {
      title: 'Poetry Slam "Nur wegen dir"',
      url: "https://www.youtube.com/embed/0c86uyGfzJo"
    }
  ];

  return (
    <>
      <div className="mb-12 bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20">
        <p className="text-base md:text-lg text-white text-left">
          Im Coaching kommt es auch stark auf die Stimme und Auftreten an und auf eine gewisse Sympathie. Deshalb kannst du hier in den drei Videos einen allerersten Eindruck von mir bekommen.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {videos.map((video, index) => (
          <div key={index} className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20 flex flex-col md:h-full">
            <h3 className="text-sm md:text-base font-bold mb-6 text-white text-center uppercase">
              {video.title}
            </h3>
            <div className="mt-auto">
              <div className="aspect-w-16 aspect-h-9">
                <iframe
                  className="w-full h-full rounded-lg shadow-lg border-2 border-white/40"
                  src={video.url}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default VideoSection;
